export let FDMTlsType = {

  Green: 1,
  Amber: 2,
  Red: 3,
  Blue: 4,
  New: 5,
  Unallocated: 6

};

export let FDMGraphType = {

  Allocated: 'Allocated',
  New: 'New',
  Reminder: 'Reminders',
  Unallocated: 'Unallocated',
  Deferred: 'Deferred'
};

export let FDMListingRouteUrl = {

  Allocated: 'JobsAndTalents/Allocation/AllocatedCandidates',
  New: 'JobsAndTalents/Allocation/NewCandidates',
  Reminder: 'JobsAndTalents/Allocation/ReminderCandidates',
  Unallocated: 'JobsAndTalents/Allocation/UnAllocatedCandidates',
  Deferred: 'JobsAndTalents/Allocation/DeferredCandidates'
};

export let Months = {

  1: 'January',
  2: 'Feburary',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'Sempteber',
  10: 'October',
  11: 'November',
  12: 'December',

};


